// WhatsApp flutuante (canto inferior direito) SEMPRE visível: por cima do menu lateral aberto (o drawer é
// z-index 101; o flutuante é 100) e também nas páginas que não o tinham (empresa, blog, empreendimento,
// construtoras). Pedido do cs2639 (25/09) — só para quem está aqui.
export const WHATS_FLUTUANTE_SEMPRE_VISIVEL = new Set<number>([2639]);

export const whatsFlutuanteSempre = (site: any): boolean =>
    WHATS_FLUTUANTE_SEMPRE_VISIVEL.has(Number(site?.id));
